import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { UsersService } from '../../services/users/users-service';
import { User } from '../../models/user';
import { AdminUsersPage } from '../admin-users/admin-users';

@IonicPage()
@Component({
  selector: 'page-admin-tabs',
  templateUrl: 'admin-tabs.html',
})
export class AdminTabsPage {
  public User: User;
  public adminUsersRoot: any = AdminUsersPage;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public userService: UsersService) {}
}



// WEBPACK FOOTER //
// ./src/pages/admin-tabs/admin-tabs.ts